module.exports = __webpack_public_path__ + "am.no2.8213cc25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/am.no2.jpg
// module id = B4Bo
// module chunks = 0